import { atom } from 'jotai';

export interface BusinessSwitchState {
  isSwitching: boolean;
  message?: string;
}

// Atom to manage business switching loader state globally
export const businessSwitchAtom = atom<BusinessSwitchState>({
  isSwitching: false,
  message: undefined,
});
